import { Helmet } from "react-helmet-async";
import { COMPANY } from "./constants";

export const SEO = ({ title, description, path = "/", image, jsonLd, type = "website" }) => {
  const url = `${COMPANY.site}${path}`;
  const img = image ? (image.startsWith("http") ? image : `${COMPANY.site}${image}`) : `${COMPANY.site}/photos/photo-01.jpg`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="pl_PL" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.label,
    item: `${COMPANY.site}${it.path}`,
  })),
});

export const articleLd = (post) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: post.meta_title || post.title,
  description: post.meta_description || post.excerpt,
  image: post.cover ? `${COMPANY.site}${post.cover}` : undefined,
  datePublished: post.published_at,
  dateModified: post.updated_at,
  author: { "@type": "Organization", name: COMPANY.fullName, url: COMPANY.site },
  publisher: { "@type": "Organization", name: COMPANY.fullName, url: COMPANY.site },
  mainEntityOfPage: `${COMPANY.site}/blog/${post.slug}`,
});
